import { render, staticRenderFns } from "./wx-login.vue?vue&type=template&id=d23834c2&scoped=true"
import script from "./wx-login.vue?vue&type=script&lang=js"
export * from "./wx-login.vue?vue&type=script&lang=js"
import style0 from "./wx-login.vue?vue&type=style&index=0&id=d23834c2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d23834c2",
  null
  
)

export default component.exports